import JSZip from "jszip"
import JSZipUtils from "jszip-utils"
import { saveAs } from "file-saver"

import Translation from "../Entities/Translation"

async function zipAndDownloadMultipleTranslationFiles(downloads, zipFileName) {
    const zip = new JSZip

    const folders = Object.entries(downloads)

    for await (const folder of folders) {
        const folderName = folder[0]
        const translationFiles = folder[1]

        for await (const translationFile of translationFiles) {
            const data = await JSZipUtils.getBinaryContent(translationFile.url);

            await zip.file(folderName + '/' + translationFile.title, data, {binary:true});
        }
    }

    const fileBlob = await zip.generateAsync({type:'blob'})
    saveAs(fileBlob, zipFileName);
}

/** @param {Translation} translation */
export default async function (translation) {
    const zipFileName = 'translation_' + translation.id + '.zip'
    const filesToBeTranslated = translation.files.toBeTranslated
    const supportFiles = translation.files.support
    const translatedFiles = translation.files.translated
    const feedbackFiles = translation.feedback?.files ?? []


    const downloads = {
        'To be translated': filesToBeTranslated,
        'Additional suport files': supportFiles,
        'Already translated': translatedFiles,
        'Feedback files': feedbackFiles,
    }

    await zipAndDownloadMultipleTranslationFiles(
        downloads,
        zipFileName
    )
}